import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.row {
    margin: calc(calc(24px / 2) * -1);
    display: flex;
    overflow: hidden;
}
.column {
    margin: calc(24px / 2);
    overflow: hidden;
}
.column.flex {
    flex: 1;
}
@media (max-width: 1080px) {
    .row {
        flex-flow: row wrap;
        margin: 0;
    }
    .summary {
        flex-flow: wrap-reverse;
        flex-direction: row-reverse;
    }
    .column,
    .column.flex {
        flex: 1;
        flex-basis: 100%;
        margin: 0;
        display: flex;
        flex-direction: column;
    }
}
/**
 * this scalable up to 50 items
 *
 * @todo replace with styled-jsx
 * dynamic styles once we figure out how to do 
 * dynamic selectors.
 */
@media (max-width: 1080px) {
    .cards-wrapper {
        display: flex;
        flex-direction: column;
    }
        .mobile-order-0 {
            order: 0;
        }
        .mobile-order-1 {
            order: 1;
        }
        .mobile-order-2 {
            order: 2;
        }
        .mobile-order-3 {
            order: 3;
        }
        .mobile-order-4 {
            order: 4;
        }
        .mobile-order-5 {
            order: 5;
        }
        .mobile-order-6 {
            order: 6;
        }
        .mobile-order-7 {
            order: 7;
        }
        .mobile-order-8 {
            order: 8;
        }
        .mobile-order-9 {
            order: 9;
        }
        .mobile-order-10 {
            order: 10;
        }
        .mobile-order-11 {
            order: 11;
        }
        .mobile-order-12 {
            order: 12;
        }
        .mobile-order-13 {
            order: 13;
        }
        .mobile-order-14 {
            order: 14;
        }
        .mobile-order-15 {
            order: 15;
        }
        .mobile-order-16 {
            order: 16;
        }
        .mobile-order-17 {
            order: 17;
        }
        .mobile-order-18 {
            order: 18;
        }
        .mobile-order-19 {
            order: 19;
        }
        .mobile-order-20 {
            order: 20;
        }
        .mobile-order-21 {
            order: 21;
        }
        .mobile-order-22 {
            order: 22;
        }
        .mobile-order-23 {
            order: 23;
        }
        .mobile-order-24 {
            order: 24;
        }
        .mobile-order-25 {
            order: 25;
        }
        .mobile-order-26 {
            order: 26;
        }
        .mobile-order-27 {
            order: 27;
        }
        .mobile-order-28 {
            order: 28;
        }
        .mobile-order-29 {
            order: 29;
        }
        .mobile-order-30 {
            order: 30;
        }
        .mobile-order-31 {
            order: 31;
        }
        .mobile-order-32 {
            order: 32;
        }
        .mobile-order-33 {
            order: 33;
        }
        .mobile-order-34 {
            order: 34;
        }
        .mobile-order-35 {
            order: 35;
        }
        .mobile-order-36 {
            order: 36;
        }
        .mobile-order-37 {
            order: 37;
        }
        .mobile-order-38 {
            order: 38;
        }
        .mobile-order-39 {
            order: 39;
        }
        .mobile-order-40 {
            order: 40;
        }
        .mobile-order-41 {
            order: 41;
        }
        .mobile-order-42 {
            order: 42;
        }
        .mobile-order-43 {
            order: 43;
        }
        .mobile-order-44 {
            order: 44;
        }
        .mobile-order-45 {
            order: 45;
        }
        .mobile-order-46 {
            order: 46;
        }
        .mobile-order-47 {
            order: 47;
        }
        .mobile-order-48 {
            order: 48;
        }
        .mobile-order-49 {
            order: 49;
        }
        .mobile-order-50 {
            order: 50;
        }
}
`;

export default styles;